import React from 'react';
import {
  Invoice,
  Payment,
  PaymentStatusEnum,
  PaymentStatusNames,
} from '@zonofi/zono-money-store';
import './payment-list.scss';
import { getInvoiceIcon } from './helper';
import moment from 'moment';
import { getFormattedAmount } from '@zonofi/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WEBROUTES } from '@zonofi/zono-money-helpers';

export const PaymentList: React.FC<{
  paymentList: Payment[];
}> = ({ paymentList }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams?.get('token');
  const sellerWorkspaceId = searchParams?.get('sellerWorkspaceId');
  const inviteId = searchParams?.get('inviteId');

  return paymentList?.map((payment, idx) => {
    const icon = getInvoiceIcon(payment.status as PaymentStatusEnum);
    return (
      <div
        key={idx}
        className="payment-list-item"
        onClick={() => {
          navigate(
            `${WEBROUTES.PAYMENT_SCREEN}/${payment.id}?token=${token}&sellerWorkspaceId=${sellerWorkspaceId}&inviteId=${inviteId}&docNumber=${payment.id}`
          );
        }}
      >
        <div className="payment-list-item-top">
          <img src={icon} alt="" />
          <div className="payment-list-item-top-details">
            <div className="payment-list-item-top-details-doc-number font-primary-semibold">
              {payment?.paymentRefCode}
            </div>
            <div className="payment-list-item-top-details-customer font-primary">
              By {payment.customerName}
            </div>
          </div>
          <div className={`payment-list-item-top-badge font-primary-semibold`}>
            {
              PaymentStatusNames[
                payment.status as keyof typeof PaymentStatusNames
              ]
            }
          </div>
        </div>
        <div className="horizontal-divider"></div>
        <div className="payment-list-item-bottom">
          <div className="payment-list-item-bottom-details">
            <div className="payment-list-item-bottom-details-label font-primary-semibold">
              Payment Date
            </div>
            <div className="payment-list-item-bottom-details-value font-primary-semibold">
              {moment(payment.paymentDate).format('MMM DD, YYYY')}
            </div>
          </div>
          <div className="payment-list-item-bottom-details">
            <div className="payment-list-item-bottom-details-label font-primary-semibold">
              Mode Of Payment
            </div>
            <div className="payment-list-item-bottom-details-value font-primary-semibold">
              {payment.paymentMode || '-'}
            </div>
          </div>
          <div className="payment-list-item-bottom-details">
            <div className="payment-list-item-bottom-details-label font-primary-semibold">
              Amount
            </div>
            <div className="payment-list-item-bottom-details-value font-primary-semibold">
              {getFormattedAmount(payment.amountPaid, true)}
            </div>
          </div>
        </div>
      </div>
    );
  });
};
